import { elevation } from '@global-engineering-shared/gweb-global-theme';
import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  tableContainer: {
    background: theme.palette.common.white,
    width: '100%',
    padding: 0,
    boxShadow: elevation.low,
    borderRadius: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  listFooter: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
  },
  totalItems: {
    color: theme.palette.neutral.dark,
  },
  loadMoreButton: {
    width: '178px',
  },
  loaderContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.spacing(2),
  },
  emptyIndicator: {
    marginTop: theme.spacing(2),

    '& > p': {
      fontSize: '0.875rem',
      color: theme.palette.neutral.dark,
    },
  },
}));

export default useStyles;
